import React from 'react';
import { FormControlLabel, SxProps, Theme } from "@mui/material";
import FormLabel from '@mui/material/FormLabel';
import { styled } from '@mui/material/styles';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { Tooltip } from "components";

export const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 1,
  '& .MuiSwitch-switchBase': {
    padding: 2,
    margin: 1,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45',
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 14,
    height: 14,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
  },
}));

export const SwitchToActivation = ({
  enabled = false,
  textOn,
  textOff,
  onChange,
  onClick,
  textLabel,
  sxLabel
}: {
  enabled: boolean,
  textOn: string,
  textOff: string,
  onChange?: () => void,
  onClick?: (e: any) => void,
  textLabel?: string
  sxLabel?: SxProps<Theme>
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
    {textLabel && <FormLabel sx={sxLabel}>{textLabel}</FormLabel>}
    <Tooltip arrow placement="top" title={enabled ? textOn : textOff}>
      <FormControlLabel
        sx={{
          margin: 0,
        }}
        control={
          <IOSSwitch
            size="small"
            checked={enabled}
            onChange={onChange}
            onClick={onClick}
          />
        }
        label=""
      />
    </Tooltip>
  </div>
)
